import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { formatInUserTimezone } from "../../utils/timezone";

/**
 * R6 — Recent edits panel for a lead.
 * Renders nothing when there are no edits or the endpoint is unavailable.
 */
export default function RecentEditsPanel({ leadId }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      if (!leadId) return;
      setLoading(true);
      try {
        const res = await api.getRecentLeadEdits?.(leadId, 25);
        const data = Array.isArray(res?.data) ? res.data : [];
        if (alive) setRows(data);
      } catch {
        if (alive) setRows([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [leadId]);

  if (!leadId) return null;
  if (!loading && rows.length === 0) return null;

  return (
    <section className="lead-panel-section">
      <div className="lead-panel-section-title">
        <i
          className="fas fa-history"
          style={{ marginRight: 8, color: "#48A0DC" }}
        />
        Recent edits
      </div>
      {loading ? (
        <div className="text-muted">Loading…</div>
      ) : (
        <ul className="r6-recent-edits-list">
          {rows.map((r) => (
            <li key={r.id} className="r6-recent-edits-row">
              <span className="r6-recent-edits-field">{r.field}</span>
              <span className="r6-recent-edits-change">
                <span className="r6-recent-edits-old">{r.old_value || "—"}</span>
                <i className="fas fa-arrow-right" />
                <span className="r6-recent-edits-new">{r.new_value || "—"}</span>
              </span>
              <span className="r6-recent-edits-date">
                {formatInUserTimezone(r.created_at)}
                {r.user_full_name ? ` · ${r.user_full_name}` : ""}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}